"use client";

import { Volume2Icon } from "lucide-react";
import { useRef } from "react";

import { cn } from "@/lib/utils";

export function PronounceMyName({
  className,
  namePronunciationUrl = "/audio/adarsh.mp3",
}: {
  className?: string;
  namePronunciationUrl: string;
}) {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  return (
    <>
      <button
        className={cn(
          "text-muted-foreground transition-colors hover:text-foreground",
          className
        )}
        onClick={() => audioRef.current?.play()}
      >
        <Volume2Icon className="size-[0.6em]" />
        <span className="sr-only">Pronounce my name</span>
      </button>
      <audio
        ref={audioRef}
        src={namePronunciationUrl}
        preload="auto"
        style={{ display: "none" }}
      />
    </>
  );
}
